export default __webpack_public_path__ + "b87bc2474aaa590b89e68259b9748ee3.png";